module.exports = __webpack_public_path__ + "static/media/IGMC.d874c619.png";